import React, { Component } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Icon from "@material-ui/core/Icon";
import ReactDatePicker from "react-datepicker";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Dot } from "recharts";
import ApiEndpoints from "../../../constants/api_endpoints";
import moment from "moment";

const LABEL = {
    fontSize: 11, fontWeight: 700, letterSpacing: "0.6px",
    textTransform: "uppercase", color: "#666", marginBottom: 6, display: "block",
};

class ClickMetricsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            start: null,
            end: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.promotion && !prevProps.promotion) {
            const start = moment().subtract(30, "days").toDate();
            const end = moment().toDate();
            this.setState({ start, end, data: [] }, () => this.fetchData());
        }
    }

    fetchData = async () => {
        const { promotion, fetchFn } = this.props;
        const { start, end } = this.state;
        if (!promotion) return;
        this.setState({ loading: true });
        try {
            const s = start ? moment(start).format("YYYY-MM-DD") : undefined;
            const e = end   ? moment(end).format("YYYY-MM-DD")   : undefined;
            const resp = fetchFn
                ? await fetchFn({ start_date: s, end_date: e })
                : await ApiEndpoints.Marketing.fetchHeroBannerClicksDaily({
                    promotion_id: promotion.promotion_id,
                    ...(s ? { start_date: s } : {}),
                    ...(e ? { end_date:   e } : {}),
                });
            this.setState({ data: resp.data.data || [], loading: false });
        } catch (err) {
            this.setState({ loading: false });
        }
    }

    render() {
        const { promotion, onClose } = this.props;
        const { data, loading, start, end } = this.state;
        const total = data.reduce((sum, d) => sum + Number(d.count), 0);

        return (
            <Modal isOpen={!!promotion} toggle={onClose} size="lg" centered>
                <div style={{
                    background: "#f1061c", borderRadius: "6px 6px 0 0",
                    padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
                }}>
                    <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
                        Clicks — {promotion && promotion.title}
                    </span>
                    <button type="button" onClick={onClose}
                        style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", padding: 4 }}>
                        <Icon style={{ fontSize: 20 }}>close</Icon>
                    </button>
                </div>

                <ModalBody style={{ padding: "20px 24px 24px" }}>

                    {/* Date Filters */}
                    <Row className="mb-3 align-items-end">
                        <Col xs={5}>
                            <label style={LABEL}>From</label>
                            <ReactDatePicker
                                selected={start}
                                maxDate={end || new Date()}
                                onChange={date => this.setState({ start: date }, () => this.fetchData())}
                                isClearable dateFormat="dd-MMM-yyyy"
                                placeholderText="Start date"
                                className="form-control" wrapperClassName="d-block"
                            />
                        </Col>
                        <Col xs={5}>
                            <label style={LABEL}>To</label>
                            <ReactDatePicker
                                selected={end}
                                minDate={start}
                                maxDate={new Date()}
                                onChange={date => this.setState({ end: date }, () => this.fetchData())}
                                isClearable dateFormat="dd-MMM-yyyy"
                                placeholderText="End date"
                                className="form-control" wrapperClassName="d-block"
                            />
                        </Col>
                        <Col xs={2}>
                            <Button size="sm" type="button" onClick={this.fetchData} style={{
                                background: "#f1061c", border: "none", color: "#fff",
                                fontWeight: 600, borderRadius: 6, width: "100%",
                            }}>
                                <Icon style={{ fontSize: 14, verticalAlign: "middle" }}>refresh</Icon>
                            </Button>
                        </Col>
                    </Row>

                    {/* Total */}
                    <div style={{ textAlign: "center", margin: "16px 0 20px" }}>
                        <span style={{ fontSize: 32, fontWeight: 800, color: "#222" }}>{total}</span>
                        <span style={{ fontSize: 13, color: "#888", marginLeft: 8 }}>total {this.props.countLabel || "clicks"} in period</span>
                    </div>

                    {/* Chart */}
                    {loading ? (
                        <div style={{ textAlign: "center", padding: "50px 0", color: "#aaa", fontSize: 13 }}>
                            <Icon style={{ fontSize: 28, display: "block", margin: "0 auto 8px", color: "#e0e0e0" }}>bar_chart</Icon>
                            Loading…
                        </div>
                    ) : data.length ? (
                        <ResponsiveContainer width="100%" height={260}>
                            <LineChart data={data} margin={{ top: 5, right: 16, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f5f5f5" />
                                <XAxis dataKey="date" tick={{ fontSize: 11 }}
                                    tickFormatter={d => moment(d).format("D MMM")} />
                                <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={32} />
                                <Tooltip
                                    formatter={value => [value, "Clicks"]}
                                    labelFormatter={label => moment(label).format("D MMM YYYY")}
                                    contentStyle={{ fontSize: 12, borderRadius: 6 }}
                                />
                                <Line type="monotone" dataKey="count" stroke="#f1061c" strokeWidth={2}
                                    dot={<Dot r={3} fill="#f1061c" />} activeDot={{ r: 5 }} name="Clicks" />
                            </LineChart>
                        </ResponsiveContainer>
                    ) : (
                        <div style={{ textAlign: "center", padding: "50px 0", color: "#aaa", fontSize: 13 }}>
                            <Icon style={{ fontSize: 28, display: "block", margin: "0 auto 8px", color: "#e0e0e0" }}>bar_chart</Icon>
                            No clicks recorded in this date range.
                        </div>
                    )}
                </ModalBody>
            </Modal>
        );
    }
}

export default ClickMetricsModal;
